<script lang="ts" setup>
import { VueDraggableNext } from 'vue-draggable-next'
import type { DraggableNode } from '~~/utils/draggable-parse'

const props = withDefaults(
  defineProps<{
    nodes: DraggableNode[]
    level?: number
    maxLevel?: number
    showGrid?: boolean
    nodeComponent?: any
  }>(),
  {
    items: () => [],
    level: 0,
  },
)
const emits = defineEmits(['showGridChange', 'add'])
const add = (targetNodes: DraggableNode[], node = {}) => {
  if (targetNodes) {
    targetNodes.push({ ...toDraggableNodes([node])[0], isNew: true })
  }
}

const onChange = (event) => {
  if (event.moved) {
    event.moved.element.isUpdated = true
  }
  if (event.added) {
    event.added.element.isUpdated = true
  }
  console.log(JSON.stringify(event, null, '  '))
}
const remove = (node) => {
  const i = props.nodes.findIndex((n) => n.id === node.id)
  props.nodes.splice(i, 1)
}
const showGridGlobal = ref(false)
const showGridChange = (value: boolean) => {
  console.log(`${props.level} -> ${value}`)
  if (props.level > 0) {
    emits('showGridChange', value)
  } else {
    showGridGlobal.value = value
  }
}
const isNotDeepestLevel = !props.maxLevel || props.level < props.maxLevel
</script>
<template>
  <VueDraggableNext
    :list="nodes"
    :group="{ name: 'g1' }"
    @start="() => showGridChange(true)"
    @end="() => showGridChange(false)"
    @change="onChange"
  >
    <div
      v-for="node in nodes"
      :key="node.id"
      class="mt-2"
      :class="{ 'my-2': !isNotDeepestLevel }"
    >
      <slot :item="node" :level="level">
        <component
          :is="nodeComponent"
          :node="node"
          :level="level"
          :children-count="node.children?.length || 0"
          @remove="remove"
        >
          <FormRichRepeater
            v-if="isNotDeepestLevel"
            :level="level + 1"
            :node-component="nodeComponent"
            :nodes="node.children"
            :max-level="maxLevel"
            class="mt-2 pl-4 py-1 pb-2 pr-2 rounded-md"
            :class="{
              'p-1/2': !node.children.length,
              'p-1': !!node.children.length,
              ['pb-4 bg-gray-' + 100 * (level + 1)]: node.children.length > 0,
              'border-dashed border-primary-100 border-2':
                (showGrid || showGridGlobal) && props.level < props.maxLevel,
            }"
            :show-grid="showGrid || showGridGlobal"
            @add="add(node.children, $event)"
            @show-grid-change="showGridChange($event)"
          />
          <Button
            v-if="!node.state.autoChildren && level < props.maxLevel"
            class="mt-4"
            variant="primary"
            @click="() => add(node.children)"
          >
            <i class="i-heroicons-solid-plus" />Add
          </Button>
        </component>
      </slot>
    </div>
    <Button
      v-if="level === 0"
      class="mt-4"
      variant="primary"
      @click="() => add(nodes)"
    >
      <i class="i-heroicons-solid-plus" />Add
    </Button>
  </VueDraggableNext>
</template>
